import axios, {
  type Axios,
  type AxiosRequestConfig,
  type AxiosError,
  type AxiosResponse,
  type AxiosPromise,
} from "axios";

const ACCOUNT_BALANCE_BASE_URL = import.meta.env.VITE_ACCOUNT_BALANCE;
export interface MyAxiosInstance extends Axios {
  (config: AxiosRequestConfig): AxiosPromise;
  (url: string, config?: AxiosRequestConfig): AxiosPromise;
}

const accountRequest = axios.create({
  baseURL: ACCOUNT_BALANCE_BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

accountRequest.interceptors.response.use(
  (response: AxiosResponse) => {
    return response.data;
  },
  async (error: AxiosError) => {
    return await Promise.reject(error.response?.data ?? error);
  }
);

export default accountRequest;
